import React from "react";
import { Link } from "react-router-dom";
import { Container, Hidden, Row, Col } from "react-grid-system";

function About() {
    return (
        <section className="section section-about section-about-1">
            <div className="display-spacing">
                <Container>
                    <Row>
                        <Hidden xs sm md>
                            <Col lg={5}>
                                <div className="about-image">
                                    <div className="image overlay-image" style={{ backgroundImage: `url(/assets/images/about/6-1.jpg)` }}></div>
                                    <Link to={`service`.replace(/([^:])(\/\/+)/g, "$1/")} style={{ position: `absolute`, bottom: 0, right: '13px' }}>
                                    <button className="button button-lg button-dark">
                                        <span className="wave"></span>
                                        <span className="text">Services</span>
                                    </button>
                                    </Link>
                                </div>
                            </Col>
                        </Hidden>
                        <Col lg={7}>
                            <div className="about-content">
                                <header className="el-heading">
                                    <h2 className="el-icon">
                                        <span className="el-icon-title">ABOUT ME</span>
                                    </h2>
                                    <h3>
                                        <span>Hello, I am Razul Mondal.</span>
                                    </h3>
                                    <div className="divider divider-1"></div>
                                    <p>Full stack developer, 10 years of experience in software development, and I specialize in efficient Android & IOS apps along with web application and api development.</p>
                                </header>
                                <Row className="pt-30">
                                    <Col xs={12} sm={12} md={6}>
                                        <div className="el-card-icon">
                                            <div className="el-icon">
                                                <span className="el-icon-icon ti-image"></span>
                                            </div>
                                            <div className="content">
                                                <h5>Web Development</h5>
                                                <p>Experience in web applications from blog to ecommerce.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6}>
                                        <div className="el-card-icon">
                                            <div className="el-icon">
                                                <span className="el-icon-icon ti-ruler-pencil"></span>
                                            </div>
                                            <div className="content">
                                                <h5>Mobile Developer</h5>
                                                <p>Experience in mobile application developer both android and IOS.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6}>
                                        <div className="el-card-icon">
                                            <div className="el-icon">
                                                <span className="el-icon-icon ti-brush-alt"></span>
                                            </div>
                                            <div className="content">
                                                <h5>React/Angular/Vue Developer</h5>
                                                <p>Experience in front-end to create a robust and effective application.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6}>
                                        <div className="el-card-icon">
                                            <div className="el-icon">
                                                <span className="el-icon-icon ti-ruler-pencil"></span>
                                            </div>
                                            <div className="content">
                                                <h5>Node Developer</h5>
                                                <p>Experience in real-time, socket, chat, api application.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6}>
                                        <div className="el-card-icon">
                                            <div className="el-icon">
                                                <span className="el-icon-icon ti-ruler-pencil"></span>
                                            </div>
                                            <div className="content">
                                                <h5>Laravel Developer</h5>
                                                <p>Experience in secure web based application and api development.</p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={6}>
                                        <div className="el-card-icon">
                                            <div className="el-icon">
                                                <span className="el-icon-icon ti-mobile"></span>
                                            </div>
                                            <div className="content">
                                                <h5>API Development</h5>
                                                <p>Experience in rest api.</p>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Hidden lg xl>
                            <Col xs={12} sm={12} md={6}>
                                <div className="el-card-icon">
                                    <div className="el-icon">
                                        <Link to={`service`.replace(/([^:])(\/\/+)/g, "$1/")}>
                                            <button className="button button-lg button-dark">
                                                <span className="wave"></span>
                                                <span className="text">Services</span>
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Hidden>
                    </Row>
                </Container>
            </div>
        </section>
    );
}

export default About;
